<template>
  <div>
    <CCard style="border-radius: 10px">
      <CRow>
        <CCol
          sm="3"
          md="3"
          lg="3"
          style="
            overflow: auto;
            max-height: 880px;
            padding-top: 10px;
            padding-bottom: 10px;
          "
        >
          <span
            style="
              padding: 7px 7px 11px 11px;
              font-size: 18px;
              line-height: 24px;
              font-weight: 600;
              color: #3b4859;
            "
            >Catalogue list<span>        <CButton color="danger" style="position:relative;left:3rem" @click="categoryAdd">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Add
        </CButton>
</span></span
          >
          <div style="padding: 10px 10px 10px 10px">
            <div>
              <TheLoader v-if="loader == true" />
             
              <table v-else>
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    v-bind:key="item.id"
                    @click="rowClick(item, index)"
                    :class="[
                      active_row == index ? 'active_row' : '',
                      'onHover',
                    ]"
                  >
                    <td style="text-align:center;padding:5px"  @click="catalogClicked(item)">
                      <p
                        for="name"
                        style="
                          cursor: pointer;
                          font-size: 14px;
                          color: #ff0000;
                          white-space: nowrap;
                          font-weight: 400;
                          line-height: 24px;
                        "                      >
                        {{ item.category }}&nbsp;
                      </p>
                    </td>
                    <td style="text-align:center;padding:5px">
                        <i
                          rel="tooltip"
                          title="Delete"
                          @click="categoryDelete(item)"
                          class="far fa-trash-alt"
                        ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </CCol>

        <CCol style="padding-left: 0px; padding-top: 10px">
          <CCol
            sm="12"
            md="12"
            lg="12"
            style="
              background-color: white;
              padding-left: 0px;
              height: fit-content;
              border-radius: 10px;
            "
          >
            <div v-if="selectedCategory">
              <span
                style="
                  font-size: 18px;
                  color: #3b4859;
                  font-weight: 600;
                "
              >
                <span v-if="isNew"> New catalog</span>
                <span v-else>{{ selectedCategory.category }} catalog</span>
              </span>
              <!-- <div style="margin-top: 10px">
                <span
                  style="
                    font-size: 14px;
                    line-height: 22px;
                    margin-bottom: 8px;
                    color: #068eef;
                    cursor: pointer;
                  "
                >
                  Preview Catalog
                </span>
              </div> -->
              <div >
                <div style="display: inline-flex" @click="change" v-if="isTab">
                  <span
                    style="
                      color: #ff0000;
                      margin: 10px 10px 10px 0px;
                      cursor: pointer;
                      border: 1px solid #ff0000;
                      border-radius: 3rem;
                      margin-left: 1rem;
                      margin-right: 1rem;
                      padding-left: 7rem;
                      padding-right: 7rem;
                      padding-top: 7px;
                      padding-bottom: 7px;
                      font-family: Montserrat;
                      font-size: 16px;
                    "
                  >
                    General
                  </span>
                </div>
                <div style="display: inline-block" @click="change" v-else>
                  <span
                    style="
                      margin: 10px 10px 10px 0px;
                      cursor: pointer;
                      border: 1px solid #f0f3f7;
                      background: #f0f3f7;
                      border-radius: 3rem;
                      margin-left: 1rem;
                      margin-right: 1rem;
                      padding-left: 7rem;
                      padding-right: 7rem;
                      padding-top: 7px;
                      padding-bottom: 7px;
                      font-family: Montserrat;
                      font-size: 16px;
                    "
                  >
                    General
                  </span>
                </div>
                <div
                  style="
                    display: inline-block;
                    cursor: pointer;
                    border: 1px solid #f0f3f7;
                    background: #f0f3f7;
                    border-radius: 3rem;
                    margin-left: 1rem;
                    margin-right: 1rem;
                    padding-left: 7rem;
                    padding-right: 7rem;
                    padding-top: 7px;
                    padding-bottom: 7px;
                    font-family: Montserrat;
                    font-size: 16px;
                  "
                  @click="changeTab"
                  v-if="isTab"
                >
                  <span> Categories </span>
                </div>
                <div
                  style="
                    display: inline-block;
                    cursor: pointer;
                    color: red;
                    margin: 10px 10px 10px 0px;
                    cursor: pointer;
                    border: 1px solid red;
                    border-radius: 3rem;
                    margin-left: 1rem;
                    margin-right: 1rem;
                    padding-left: 7rem;
                    padding-right: 7rem;
                    padding-top: 7px;
                    padding-bottom: 7px;
                    font-family: Montserrat;
                    font-size: 16px;
                  "
                  @click="changeTab"
                  v-else
                >
                  <span> Categories </span>
                </div>
              </div>
            </div>
          </CCol>

          <CCol
            sm="12"
            md="12"
            lg="12"
            v-if="isTab"
            style="padding-left: 0px; padding-right: 0px"
          >
            <div
              style="
                padding: 10px;
                background: border-box;
                border: 1px solid gainsboro;
                border-radius: 10px;
                margin-right: 10px;
                margin-top: 10px;
                margin-bottom: 10px;
              "
              v-if="selectedCategory"
            >
              <CRow>
                <CCol sm="8" md="8" lg="8">
                  <CCol sm="12" md="12" lg="12">
                    <span class="label">Name</span>
                  </CCol>
                  <CCol
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                        <div class="form-group">
                          <input
                            type="text"
                            v-model="selectedCategory.category"
                            id="name"
                            name="name"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                submitted && $v.selectedCategory.category.$error,
                            }"
                          />
                          <div
                            v-if="submitted && !$v.selectedCategory.category.required"
                            class="invalid-feedback"
                          >
                            Catalog is required
                          </div>
                        </div>
                    
                  </CCol>
                </CCol>

                <CCol
                  style="
                    padding: 12px 18px;
                    height: fit-content;
                    margin-right: 20px;
                  "
                >
                  <span class="label">Availability</span>
                  <br />
                  <div>
                    <CSwitch
                      class="mx-1"
                      color="success"
                      name="switch1"
                      :checked.sync="togglePress"
                      variant="3d"
                      size="sm"
                      style="margin-bottom: -5px"
                    />
                    <CBadge v-if="togglePress">
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Enable
                      </h6>
                    </CBadge>
                    <CBadge v-else class="form-input">
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Disable
                      </h6>
                    </CBadge>
                  </div>
                </CCol>

                <CCol
                  sm="12"
                  md="12"
                  lg="12"
                  style="
                    padding: 4px;
                    border-top: 1px solid gainsboro;
                    margin-top: 15px;
                  "
                >
                </CCol>
                <CCol>
                  <CRow>
                    <CCol lg="4">
                      <img
                        :src="imageFileDisp"
                        class="image-wrapper"
                        v-if="imageFileDisp"
                      />
                      <img
                        src="../../assets/product-default.svg"
                        class="image-wrapper"
                        v-else
                      />
                    </CCol>
                    <CCol lg="8">
                      <div style="padding-top: 20px">
                        <CCard>
                          
                          <CCardBody>
                            <div class="row">
                              <div class="col-8">
                                <label class="label2">
                                  Upload / change catalog image
                                </label>

                                <input
                                  type="file"
                                  @change="onImageSelected"
                                  accept="image/*"
                                  class="form-control label2"
                                                      tabindex="-1"
/>
                              </div>
                              <div class="col">
                                <div
                                  @click="deleteImage"
                                  style="
                                    background: whitesmoke;
                                    cursor: pointer;
                                    border-radius: 3rem;
                                    text-align: center;
                                    padding-top: 4px;
                                    padding-bottom: 4px;
                                    margin-top: 2rem;
                                    font-size: 14;
                                    font-family: 'Montserrat';
                                    color: #8392a7;
                                    font-weight: 400;
                                    margon-bottom: 1rem;
                                    border: 1px solid whitesmoke;
                                  "
                                >
                                  <span> Delete </span>
                                </div>
                              </div>
                            </div>
                          </CCardBody>
                        </CCard>
                      </div>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol
                  sm="12"
                  md="12"
                  lg="12"
                  style="
                    border-top: 1px solid gainsboro;
                  "
                >
                </CCol>
                <CCol>
                    <div class="form-group">
                      <label>About Catalog</label>
                        <b-form-textarea
                          id="textarea"
                          v-model="selectedCategory.description"
                          placeholder="About Catalog..."
                          rows="3"
                          max-rows="6"
                          
                        ></b-form-textarea>
                       
                      </div>
                      
                </CCol>
                <div>
                          <CButton
          v-if="isNew == false"
          @click="onSubmit('edit')"
          style="float: right;background:red;color:white"
        >
          Save changes
          <b-spinner v-if="savechanges" small type="grow"></b-spinner>
        </CButton>
        <CButton
          v-if="isNew == true"
          @click="onSubmit('add')"
          style="float: right;background:red;color:white"
        >
          Save Catalog
          <b-spinner v-if="savecatalog" small type="grow"></b-spinner>
        </CButton>

                </div>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12" md="12" lg="12" v-else>
            <CCard
              style="
                margin-top: 10px;
                margin-bottom: 10px;
                margin-left: -15px;
                margin-right: 5px;
              "
            >
              <CCardHeader class="form-input">
                Categories
                <span>
                  <CButton
                    style="
                      float: right;
                      background: red;
                      font-family: 'Montserrat';
                      color: white;
                      font-weight: 400;
                      border-radius: 6px;
                    "
                    @click="gotocategory"
                    >Add</CButton
                  >
                </span>
              </CCardHeader>
              <CCardBody>
                <!-- <div class="row" style="padding-top: 5px; padding-bottom: 10px">
                  <div class="col-4">
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      placeholder="Search"
                      style="border-radius: 3rem"
                    >
                    </b-form-input>
                    <span style="position: relative; top: -1.8rem; left: 12rem"
                      ><i class="fa fa-search" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="col-6">
                    <b-pagination
                      v-model="currentPage"
                      pills
                      :total-rows="rows"
                    ></b-pagination>
                  </div>

                  <div class="col-2">
                    <b-form-select
                      style="width: 3.5rem; border-radius: 3rem"
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                    ></b-form-select>
                  </div>
                </div>

                <b-table
                  :items="productItem"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  show-empty
                  caption-top
                >
                  <template #name="{ item }">
                    <td style="cursor: pointer !important">
                      <span @click="editOrder(item)">{{ item.name }}</span>
                    </td>
                  </template>
                </b-table> -->

                <CDataTable
                  :items="productItem"
                  :fields="fields"
                  :tableFilter="{ placeholder: 'search', label: 'Search' }"
                  items-per-page-select
                  :items-per-page="10"
                  hover
                  sorter
                  pagination
                  
                >
                  <template #name="{ item }">
                    <td @click="editOrder(item)" style="cursor: pointer">
                      <span
                        class="form-input"
                        style="text-decoration: underline"
                        >{{ item.name }}</span
                      >
                    </td>
                  </template>
                </CDataTable>
              </CCardBody>
            </CCard>
          </CCol>
        </CCol>
      </CRow>
    </CCard>
    <!--end -->
    <CModal title="Category Added" color="success" :show.sync="successModal">
      Category added successfully to the store.
    </CModal>
  </div>
</template>
<script>
$("tr").click(function () {
  $(this).addClass("selected").siblings().removeClass("selected");
});
$(document).ready(function () {
  $("[rel=tooltip]").tooltip({ placement: "right" });
});
</script>
<script>
import firebase from "firebase";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Vue from "vue";
import { uuid } from "vue-uuid";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
import Upload from "../components/fileupload";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
import Table from "../tables/Table.vue";
import TheLoader from "../components/TheLoader.vue";
import { cifJp, cilArrowThickRight } from "@coreui/icons";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
Vue.use(VueQuillEditor);

export default {
  name: "Categorytable",
  components: {
    vSelect,
    Upload,
    Table,
    TheLoader,
  },
  data: () => {
    return {
      loader: false,
      deletecatalog: false,
      selected: "",
      selected1: "",
      categoryOption: [],
      togglePress: false,
      userId: "",
filterCatalog:'',
      itemsvaluee: "",
      id: "",
      datavalue: "",
      updatedatavalue: "",
      items: [],
      filter: "",
      datavalue: "",
      totalRows: 1,
      active_row: "",

      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],

      idvalues: [],
      values: [],
      Items: [],
      list: [" "],
      savecatalog: false,
      savechanges: false,
      itemdelete: null,
      selectedCategory: {},
      isNew: true,
      imageFileDisp: false,
      imageData: null,
      img1: "",
      isTab: true,
      productData: null,
      productItem: [],
      successModal: false,
      isSubmit: false,
      isedit: false,
      $permissionError: 0,
      fieldscatalog:[
        {
          key:"name",
          label:"Name"
        }
      ],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          sortDirection: "desc",
          _style: "text-decoration:underline",
        },
      ],
      upload: false,
      submitted:false,
    };
  },
  computed: {
    isValid() {
      return !this.$v.selectedCategory.$invalid;
    },
    isDirty() {
      return this.$v.selectedCategory.$anyDirty;
    },
  },
  mixins: [validationMixin],

  validations: {
    selectedCategory: {
      category: {
        required,
      },
    },
    selected:{required}
  },
  methods: {
    rowClick(item, index) {
      this.active_row = index;
    },

    handlecb(csvvalues) {
      const db = firebase.firestore();
      csvvalues.forEach((doc) => {
        doc["name"] = doc.catalog;
        doc["id"] = firebase.auth().currentUser.uid;
        doc["available"] = true;
        if (
          doc["category"] == "" ||
          doc["catalog"] == "" ||
          doc["subcategory"] == "" ||
          doc["skucode"] == "" ||
          doc["product"] == "" ||
          doc["image"] == "" ||
          doc["description"] == "" ||
          doc["unit"] == "" ||
          doc["mrp"] == "" ||
          doc["unitprice"] == "" ||
          doc["discount"] == "" ||
          doc["featured"] == "" ||
          doc["barcode"] == ""
          // discount,barcode,subcat,image,desc,faetured,
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          Vue.$toast.error("Please enter valid product details", {
            position: "top-right",
          });

          return;
        } else {
          db.collection("catalog")
            .where("id", "==", firebase.auth().currentUser.uid)
            .where("name", "==", doc.catalog)
            .get()
            .then((snapshot) => {
              console.log("length1234", snapshot.docs.length, doc);
              if (snapshot.docs.length == 0) {
                db.collection("catalog").add({
                  available: true,
                  id: firebase.auth().currentUser.uid,
                  image: doc["image"],
                  name: doc["catalog"],
                });

                Vue.$toast.success("Catalog added successfully!", {
                  position: "top-right",
                });
              }
            });
        }
      });
      csvvalues.forEach((doc1) => {
        doc1["name"] = doc1.category;

        doc1["id"] = firebase.auth().currentUser.uid;
        doc1["available"] = true;
        if (
          doc1["category"] == "" ||
          doc1["catalog"] == "" ||
          doc1["subcategory"] == "" ||
          doc1["skucode"] == "" ||
          doc1["product"] == "" ||
          doc1["image"] == "" ||
          doc1["description"] == "" ||
          doc1["unit"] == "" ||
          doc1["mrp"] == "" ||
          doc1["unitprice"] == "" ||
          doc1["discount"] == "" ||
          doc1["featured"] == "" ||
          doc1["barcode"] == ""
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          // Vue.$toast.error("Please enter valid product details", {
          //   position: "top-right",
          // });

          return;
        } else {
          db.collection("category")
            .where("id", "==", firebase.auth().currentUser.uid)
            .where("name", "==", doc1.category)
            .get()
            .then((snapshot) => {
              console.log("length34343", snapshot.docs.length);
              if (snapshot.docs.length == 0) {
                db.collection("category").add({
                  catalog: [doc1["catalog"]],
                  id: firebase.auth().currentUser.uid,
                  image: doc1["image"],
                  name: doc1["name"],
                });
                Vue.$toast.success("Category added successfully!", {
                  position: "top-right",
                });
              }
            });
        }
      });
      csvvalues.forEach((doc2) => {
        doc2["name"] = doc2.name;

        doc2["category"] = doc2.category;
        doc2["catalog"] = doc2.catalog;
        doc2["id"] = firebase.auth().currentUser.uid;
        doc2["available"] = true;
        doc2["image"] = doc2.image;
        doc2["unitprice"] = doc2.unitprice;
        doc2["description"] = doc2.description;
        if (
          doc2["category"] == "" ||
          doc2["catalog"] == "" ||
          doc2["subcategory"] == "" ||
          doc2["skucode"] == "" ||
          doc2["product"] == "" ||
          doc2["image"] == "" ||
          doc2["description"] == "" ||
          doc2["unit"] == "" ||
          doc2["mrp"] == "" ||
          doc2["unitprice"] == "" ||
          doc2["discount"] == "" ||
          doc2["featured"] == "" ||
          doc2["barcode"] == "" 
          
        ) {
          console.log("sdfghjklcfvgbhjnkm");
          // Vue.$toast.error("Please enter valid product details", {
          //   position: "top-right",
          // });

          return;
        } else {
          db.collection("products")
            .where("name", "==", doc2["product"])
            .where("id", "==", firebase.auth().currentUser.uid)
            .get()
            .then((snapshot) => {
              if (snapshot.docs.length == 0) {
                db.collection("products")
                  .add({
                    available: true,
                    barcode: doc2["barcode"],
                    Id: firebase.auth().currentUser.uid,
                    Image: doc2["image"],
                    brand: doc2["brand"],
                    catalog: doc2["catalog"],
                    category: [doc2["category"]],
                    description: doc2["description"],
                    discount: doc2["discount"],
                    enable: true,
                    name: doc2["product"],
                    featured: true,
                    id: firebase.auth().currentUser.uid,
                    image: doc2["image"],
                    skucode: doc2["skucode"],
                    unit: doc2["stock"],
                    unitprice: doc2["unitprice"],
                    mrp: doc2["mrp"],
                    featured: doc2["featured"],
                    // userid:newid,
                    variant: "",
                    variants: "",
                    weight: doc2["unit"],
                  })
                  .then(() => {
                    Vue.$toast.success("Product added successfully!", {
                      position: "top-right",
                    });
                  });

                // db.collection("products").add(doc);
                // });
              }
            });
        }
      });
    },
    if($permissionError) {
      Vue.$toast.error("Please Enter Valid Products!", {
        position: "top-right",
      });
    },
    changedLabel(event) {
      console.log(event);
      //  this.selectedCategory.category=event;
      this.selected = event;
      this.selectedCategory.category = event;
      console.log(this.selectedCategory);
      console.log(event, this.selected, "selected");
    },
    checkIfValid(fieldName) {
      const field = this.$v.selectedCategory[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model == "");
    },
    deleteImage() {
      this.imageFileDisp = false;
    },
    change() {
      console.log("Moved to general");
      this.isTab = true;
    },
    changeTab() {
      console.log("moved to category");
      this.isTab = false;
    },
    categoryAdd() {
      this.isNew = true;
      this.imageFileDisp = false;
      this.selectedCategory = {};
            this.selected = '';

      this.isSubmit = false;
    },
    onImageSelected(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFileImage(files[0]);
      this.previewImage(e);
    },
    createFileImage(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.imageFileDisp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    previewImage: function (event) {
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event.target.files[0];
      this.uuidvalue = uuid.v1();
      this.onUpload();
    },
    onUpload() {
      this.img1 = null;
      const storageRef = firebase
        .storage()
        .ref(this.uuidvalue)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.img1 = url;
            console.log("Probably stored", this.img1);
            return this.img1;
          });
        }
      );
    },
    close() {
      this.upload = false;
    },

    onSubmit(type) {
      this.submitted=true

      if (type == "add") {
this.$v.selectedCategory.category.$touch();

      if (
        this.$v.selectedCategory.category.$invalid 
      ) {
        this.loader = false;
        this.savecatalog =false;
        return;
      }

        this.loader = true;
        this.savecatalog = true;
 
          const db = firebase.firestore();
          db.collection("catalog")
            .where("name", "==", this.selectedCategory.category)
            .get()
            .then((snapshot) => {
              if (snapshot.docs.length == 0) {
                db.collection("catalog")
                  .add({
                    name: this.selectedCategory.category,
                    description: this.selectedCategory.description,
                    image: this.img1,
                    id: firebase.auth().currentUser.uid,
                    available: this.togglePress,
                  })
                  .then(() => {
                    this.selectedCategory = {};
                    this.loader = false;
                    this.items = [];
                    this.getCatalogList();
                    this.imageFileDisp = false;
                    this.img1 = null;
                    this.isSubmit = false;
                    Vue.$toast.success("Catalog added successfully!", {
                      position: "top-right",
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                    Vue.$toast.error(error, {
                      position: "top-right",
                    });
                  });
              } else {
                Vue.$toast.error("Catalog name already exist", {
                  position: "top-right",
                });
              }
            });
      } else {
              this.$v.selectedCategory.category.$touch();

      if (
        this.$v.selectedCategory.category.$invalid 
      ) {
        this.loader = false;
        this.savechanges =false;
        return;
      }

        this.loader = true;
        this.savechanges = true;
        const db = firebase.firestore();
        console.log("selected", this.selectedCategory.parentCategory);
        if (!this.selectedCategory.parentCategory) {
          this.selectedCategory.parentCategory = null;
        }
        db.collection("catalog")
          .doc(this.selectedCategory.userid)
          .update({
            name: this.selectedCategory.category,
            description: this.selectedCategory.description,
            image: this.img1,
            id: firebase.auth().currentUser.uid,
            available: this.togglePress,
          })
          .then(() => {
            this.loader = false;
            this.items = [];
            this.getCatalogList();
            this.savechanges = false;
            this.selectedCategory = {};
            this.imageFileDisp = false;
            this.img1 = null;
            this.isSubmit = false;
            Vue.$toast.success("Catalog updated successfully!", {
              position: "top-right",
            });
          })
          .catch((error) => {
            console.log(error);
            Vue.$toast.error(error, {
              // override the global option
              position: "top-right",
            });
          });
      }
    },
    catalogClicked(item) {
      console.log("catalog", item);
      this.isNew = false;
      this.selected = item.category;
      this.selectedCategory = item;
      this.togglePress = item.togglePress;
      console.log(this.selectedCategory);
      this.imageFileDisp = item.Image;
      this.getproductList();
    },
    categoryDelete(item) {
      console.log(item);
      this.$bvModal
        .msgBoxConfirm("Are you sure to delete this Catalog.", {
          title: "Delete catalog",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.deletecatalog = value;
      this.loader = true;

          if (this.deletecatalog == true) {
            const db = firebase.firestore();
            db.collection("catalog")
              .doc(item.userid)
              .delete()
              .then(() => {
                this.loader = false;
                this.item = {};
                this.imageFileDisp = null;
                this.img1 = null;
                Vue.$toast.success("Catalog deleted successfully!", {
                  position: "top-right",
                });
                this.items = [];
                this.getCatalogList();
              })
              .catch(function (error) {
                console.error("Error removing document: ", error);
                Vue.$toast.error(error, {
                  position: "top-right",
                });
              });
          }else{
            this.loader=false;
          }
        })
        .catch((err) => {
          Vue.$toast.error(err, {
            position: "top-right",
          });
        });
    },

    // },
    getCatalogList() {
      this.loader = true;
      const db = firebase.firestore();
      this.categoryOption = [];
      db.collection("businessType")
        .get()
        .then((querySnapshot) => {
          this.list = querySnapshot.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          console.log(this.list);
        });
      db.collection("catalog")
        .where("id", "==", firebase.auth().currentUser.uid)
        .orderBy("name")
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            console.log(doc.data(), "catalog");
            this.id = doc.id;
            this.categoryOption.push(doc.data().category);
            this.datavalue = {
              userid: doc.id,
              categoryid: doc.data().id,
              Image: doc.data().image,
              Id: doc.data().id,
              category: doc.data().name,
              description: doc.data().description,
              expiry: doc.data().expiry,
              manufacturer: doc.data().manufacturer,
              name: doc.data().name,
              togglePress: doc.data().available ? doc.data().available : false,
              quality: doc.data().quality,
              quantity: doc.data().quantity,
              skucode: doc.data().skucode,
              unitofquantity: doc.data().unitofquantity,
              unitprice: doc.data().unitprice,
              warranty: doc.data().warranty,
              weight: doc.data().weight,
            };
            console.log(this.datavalue);
            this.items.push(this.datavalue);
            console.log(this.items);
          });
        });
    },
    getproductList() {
      this.productItem = [];
      const db = firebase.firestore();
      this.conaddress = [];
      this.conaddress.push(this.selectedCategory.category);
      console.log(this.conaddress);
      db.collection("category")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(typeof doc.data().catalog);
            if (
              typeof doc.data().catalog == "object" &&
              doc.data().id == firebase.auth().currentUser.uid
            ) {
              for (var i = 0; i < doc.data().catalog.length; i++) {
                if (
                  doc.data().id == firebase.auth().currentUser.uid &&
                  doc.data().catalog[i] == this.selectedCategory.category
                ) {
                  console.log(doc.data().image);
                  this.productData = {
                    userid: doc.id,
                    Image: doc.data().image,
                    Id: doc.data().id,
                    catalog: doc.data().catalog,
                    category: doc.data().name,
                    certification: doc.data().certification,
                    company: doc.data().company,
                    description: doc.data().description,
                    expiry: doc.data().expiry,
                    manufacturer: doc.data().manufacturer,
                    name: doc.data().name,
                    quality: doc.data().quality,
                    quantity: doc.data().quantity,
                    skucode: doc.data().skucode,
                    unitofquantity: doc.data().unitofquantity,
                    unitprice: doc.data().unitprice,
                    warranty: doc.data().warranty,
                    weight: doc.data().weight,
                    mrp: doc.data().mrp,
                    featured: doc.data().featured,
                  };
                  this.productItem.push(this.productData);
                } else {
                }
              }
            } else {
              if (
                doc.data().id == firebase.auth().currentUser.uid &&
                doc.data().catalog == this.selectedCategory.category
              ) {
                console.log(doc.id);
                this.productData = {
                  userid: doc.id,
                  Image: doc.data().image,
                  Id: doc.data().id,
                  catalog: doc.data().catalog,
                  category: doc.data().name,
                  certification: doc.data().certification,
                  company: doc.data().company,
                  description: doc.data().description,
                  expiry: doc.data().expiry,
                  manufacturer: doc.data().manufacturer,
                  name: doc.data().name,
                  quality: doc.data().quality,
                  quantity: doc.data().quantity,
                  skucode: doc.data().skucode,
                  unitofquantity: doc.data().unitofquantity,
                  unitprice: doc.data().unitprice,
                  warranty: doc.data().warranty,
                  weight: doc.data().weight,
                  mrp: doc.data().mrp,
                  featured: doc.data().featured,
                };
                this.productItem.push(this.productData);
              }
            }
          });
        });
    },
    gotocategory() {
      this.$router.push({
        name: "Category",
      });
    },
    editOrder(item) {
      this.$router.push({
        name: "Category",
        params: {
          id: item.userid,
          data: item,
        },
      });
      var url = window.location.hash;

      let dropwnMenu = document.getElementById("dropdown-accordion");
      let aTags = dropwnMenu.getElementsByTagName("a");
      let liTags = dropwnMenu.getElementsByTagName("li");
      let idCommon = "";

      for (let j = 0; j < aTags.length; j++) {
        let hrefLink = liTags[j].getAttribute("href");

        console.log(liTags[j], "uu");

        if (hrefLink == url) {
          idCommon = liTags[j].parentNode.id;
          $("#" + idCommon).addClass("active");
        } else {
          liTags[j].parentNode.removeClass("active");
        }
      }
    },
  },
  mounted: function () {
    this.getCatalogList();
    if (this.$route.params.length) {
      console.log(this.$route.params);
      let item = this.$route.params.data;
      this.isNew = false;
      this.selectedCategory = item;
      this.imageFileDisp = item.Image;
      this.selectedCategory.category = item.name;
      console.log("kjjijiojij", this.selectedCategory.category);
      this.getproductList();
    }
  },
};
</script>
<style scoped >
.active_row {
  background: #ffe2df !important;
}
.image-wrapper {
  width: 150px;
  height: 150px;
  padding-bottom:10px;
  vertical-align: middle;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

table,
td {
  border: 1px solid gainsboro;
  width: 100%;
  padding: 5px;
  cursor: pointer !important;
}

.form-control {
  font-size: 14px;
  color: #3b4859;
  font-weight: 600;
}
.b-pagination-pills .page-item .page-link {
  border-radius: 50rem;
  margin-left: 0.25rem;
  line-height: 1;
  color: #8998ac !important;
  border: white;
}

.page-item.active .page-link {
  color: rgb(15, 14, 14) !important;
  background: #ff0000;
  border: #ff0000;
}
</style>
